import QRCode from 'qrcode';

export const getQrCode = async ({
  url,
  size = 256,
  bgColor,
  fgColor = '#000000',
  margin = 0,
  ...rest
}) => {
  const qrCode = await QRCode.toDataURL(url, {
    width: size,
    margin,
    color: {
      dark: fgColor,
      light: !bgColor ? '#0000' : bgColor
    },
    ...rest
  });

  return qrCode;
};
